
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Fest',
	'find_label': 'Søk',
	'findCancelLabel': 'Avbryt',
	'sourcePaneLabel': 'Valgte kilder',
	'sourcePaneContentLabel': 'Velg en kilde',
	'addDataDashboardCoachMarkContents': 'Dra og slipp data fra datapanelet til dashbordet.',
	'addDataStoryCoachMarkContents': 'Dra og slipp data fra datapanelet til historien.',
	'addDataCoachMarkTitle': 'Legg til data',
	'selectSourcesText': 'Velg og legg til en datakilde for å bygge din %{app}.',
	'selectSourcesLabel': 'Velg en kilde',
	'errorSourcesTitle': 'Kunne ikke laste inn datatreet',
	'errorLoadingDataSources': 'Det oppstod en feil ved lasting av listen med datasett',
	'errorLoadingDataTree': 'Det oppstod en feil ved innlasting av treet',
	'dataSetPaneLastUpdated': 'Sist oppdatert: %{date}',
	'dataSourcePaneDateUnknown': 'Ukjent',
	'moreTitle': 'Mer',
	'backLabel': 'Gå tilbake',
	'addDataSourceDialogTitle': 'Legg til en datakilde',
	'addDataSourceDialogButtonLabel': 'Legg til',
	'dlg_use': 'Bruk',
	'dlg_RelinkDataSourceTitle': 'Erstatt datasett \'%{dataSourceName}\' med ...',
	'propertiesDialogTitle': 'Egenskaper',
	'missingDataSetData': 'Dataene for dette datasettet er ikke tilgjengelige. Oppdater datasettet eller kontakt administratoren for å få tilgang til kilden.',
	'errorLoadingSource': 'Metadataene for \'%{sourceName}\' ble ikke lastet inn. Kontakt administratoren for å få mer informasjon.',
	'errorMessageTitle': 'Feil',
	'calculation_navigation_in_use': 'Hvis beregninger eller navigeringsbaner slettes, blir alle visualiseringer som refererer til det slettede elementet, ugyldig. Er du sikker på at du vil slette?',
	'delete_confirm': 'Bekreft sletting',
	'previewUnavailable': 'Dataskuffen og de globale filtrene er ikke tilgjengelig for denne pakketypen.',
	'contextualGridTabName': 'Visualiseringsdata',
	'DATA_TRAY_no_data_text': '\'Dataene dine vil bli vist her.\'',
	'contextualGridMenuLabel': 'Menyen Visualiseringsdata',
	'contextualGridExport': 'Eksporter',
	'nullValueText': 'Null',
	'forecastDetailsTabName': 'Statistiske opplysninger for prognose',
	'forecastDetailsModelLabel': 'Modell',
	'forecastDetailsQualityMetricLabel': 'Nøyaktighetsmål',
	'forecastDetailsSmoothingCoefLabel': 'Parametere',
	'forecastDetailsDiagnostics': 'Diagnostikk',
	'forecastDetailsForecastLabel': 'Prognose',
	'forecastDetailsStatusLabel': 'Status',
	'forecastDetailsAccuracyPercentLabel': 'Nøyaktighetsprosent',
	'forecastDetailsTrendLabel': 'Trend',
	'forecastDetailsSeasonLabel': 'Sesongsvingning',
	'forecastDetailsSeasonalPeriodLabel': 'Sesongperiode',
	'forecastDetailsAlphaLabel': 'Alfa',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gamma',
	'forecastDetailsPhiLabel': 'Phi',
	'forecastDetailsMissingCount': 'Mangler antall',
	'forecastDetailsSeriesLengthLabel': 'Serielengde',
	'forecastDetailsIgnoredPeriods': 'Ignorerte perioder',
	'forecastDetailsTrendStrength': 'Trendstyrke',
	'forecastDetailsSeasonalityStrength': 'Sesongstyrke',
	'forecastDetailsTimeDeltaUnit': 'Dato-/tidsintervall',
	'forecastDetailsNotes': 'Merknader'
});
